.control {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-height: var(--size-control-md);
  padding: 0 var(--space-3);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-md);
  background: var(--color-field);
  color: var(--color-text-primary);
  transition:
    border-color var(--duration-fast-02) var(--ease-standard),
    box-shadow var(--duration-fast-02) var(--ease-standard);
}

.control:hover {
  border-color: var(--color-border-strong-hover);
}

.control:focus-within {
  border-color: var(--color-focus);
  box-shadow: 0 0 0 1px var(--color-focus);
}

.control[data-invalid='true'] {
  border-color: var(--color-error);
  box-shadow: 0 0 0 1px var(--color-error);
}

.control[data-invalid='true']:focus-within {
  border-color: var(--color-focus);
  box-shadow: 0 0 0 1px var(--color-focus);
}

.control[data-disabled='true'] {
  border-color: var(--color-border-subtle);
  background: var(--color-field-disabled);
  color: var(--color-text-disabled);
  cursor: not-allowed;
}

.control[data-readonly='true'] {
  background: var(--color-layer-1);
  border-color: var(--color-border-subtle);
}

.sm {
  min-height: var(--size-control-sm);
}

.lg {
  min-height: var(--size-control-lg);
}

.input {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  height: calc(var(--size-control-md) - 2px);
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  /* 16 px в поле ввода: iOS Safari не увеличивает страницу при фокусе. */
  font-size: var(--type-input-size);
  line-height: var(--type-body-line);
  outline: none;
}

.sm .input {
  height: calc(var(--size-control-sm) - 2px);
  font-size: var(--type-body-sm-size);
}

.lg .input {
  height: calc(var(--size-control-lg) - 2px);
}

.input:disabled {
  cursor: not-allowed;
  color: var(--color-text-disabled);
}

.input::-webkit-search-cancel-button {
  display: none;
}

.icon {
  flex-shrink: 0;
  fill: var(--color-icon-secondary);
}

.suffix {
  flex-shrink: 0;
  color: var(--color-text-secondary);
  font-size: var(--type-body-sm-size);
  white-space: nowrap;
}

.trailing {
  display: flex;
  align-items: center;
  margin-inline-end: calc(var(--space-2) * -1);
}

.invalidIcon {
  flex-shrink: 0;
  fill: var(--color-error-icon);
}

.textareaControl {
  align-items: stretch;
  padding: var(--space-2) var(--space-3);
}

.textarea {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  min-height: 88px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font-size: var(--type-body-size);
  line-height: var(--type-body-line);
  resize: vertical;
  outline: none;
}

.autosize {
  resize: none;
  overflow: hidden;
}

.counter {
  align-self: flex-end;
  color: var(--color-text-helper);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
  font-variant-numeric: tabular-nums;
}

.counterOver {
  color: var(--color-error);
}

.textareaWrap {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}
